<template>
  <div ref="tooltipRef">
    <a-tooltip :arrowPointAtCenter="false"  :placement="placement" :getPopupContainer="() => tooltipRef">
    <template #title v-if="showTooltip">
          <div class="auto-tooltip__content" :style="{ maxWidth: contentWidth + 'px' }">{{showTooltip ? String(content) : null}}</div>
    </template>
    <span ref="contentRef" class="auto-tooltip__ellipsis" :style="spanStyle">
      {{ content }}
    </span>
  </a-tooltip>
  </div>
  
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, watch, nextTick } from 'vue'

const props = defineProps({
  content: { type: [String, Number], default: '' },
  width: { type: [String, Number], default: 200 },
  placement: { type: String, default: 'top' },
  contentWidth: { type: [String, Number], default: 180 },
  hasUnderline: { type: Boolean, default: false }
})

const contentRef = ref(null)
const showTooltip = ref(false)
const tooltipRef = ref(null)
const spanStyle = computed(() => ({
  maxWidth: typeof props.width === 'number' ? props.width + 'px' : props.width,
  display: 'inline-block',
  textDecoration: props.hasUnderline ? 'underline' : 'none'
}))

let resizeObserver = null
const handleCheckOverflow = () => {
  const el = contentRef.value
  if (!el) return
  showTooltip.value = el.scrollWidth > el.clientWidth
}

const setupResizeWatchers = () => {
  const el = contentRef.value
  if (!el) return
  if ('ResizeObserver' in window) {
    resizeObserver = new ResizeObserver(() => handleCheckOverflow())
    resizeObserver.observe(el)
  } else {
    window.addEventListener('resize', handleCheckOverflow)
  }
}

onMounted(async () => {
  await nextTick()
  handleCheckOverflow()
  setupResizeWatchers()
})

onBeforeUnmount(() => {
  if (resizeObserver) {
    resizeObserver.disconnect()
    resizeObserver = null
  } else {
    window.removeEventListener('resize', handleCheckOverflow)
  }
})

watch(() => [props.content, props.width], async () => {
  await nextTick()
  handleCheckOverflow()
})
</script>

<style scoped>
.auto-tooltip__ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}
.auto-tooltip__content{
  word-break:  break-word;

}
</style>